import { LearnerFragment } from "@outschool/ui-components-classroom";

export default LearnerFragment;
